export default __webpack_public_path__ + "static/wvs-9530e67e4c684d0c9492bd33ac5d84ee.jpg";